import { GradientPath } from './GradientPath';

type Props = {
  className?: string;
};

export const Check = ({ className }: Props) => {
  return (
    <GradientPath
      className={className}
      height={38}
      width={38}
      render={(id) => (
        <g fill={`url(#${id})`}>
          <path d="m18 35.92a18 18 0 1 1 18-18 18 18 0 0 1 -18 18zm0-34.78a16.82 16.82 0 1 0 16.78 16.86 16.84 16.84 0 0 0 -16.78-16.86z" />
          <path d="m15.1 25a.57.57 0 0 1 -.43-.95l11.43-12.9a.57.57 0 0 1 .85.75l-11.42 12.88a.57.57 0 0 1 -.43.22z" />
          <path d="m15.1 25a.57.57 0 0 1 -.43-.2l-5.72-6.69a.57.57 0 1 1 .86-.74l5.73 6.63a.57.57 0 0 1 -.06.8.56.56 0 0 1 -.38.2z" />
        </g>
      )}
    />
  );
};
